<script>
    import { createEventDispatcher } from 'svelte'

    export let list
    export let property

    const dispatch = createEventDispatcher()

    const selectTile = (id) => {
        dispatch('selectTile', { id })
    }
</script>

<style>
    li.scale_tile:hover {
        transform: scale(1.2);
    }
</style>

<ul class="flex flex-wrap">
    {#each list as item}
        <li
            on:click={() => selectTile(item)}
            class="scale_tile flex flex-col justify-center h-14 w-14 bg-teal-50 hover:bg-teal-700 border-2 border-gray-500 hover:border-blue-300 rounded text-center font-bold text-gray-800 hover:text-gray-100 m-0.5 cursor-pointer"
        >
            <p>{item[property]}</p>
        </li>
    {/each}
</ul>
